
import { ServiceContainer, CrudService, AuthService } from 'yellowfin-ui-lib';
import { AnagraficaService } from '@/data/services/anagrafica.service';
import { SpecializzazioneService } from '@/data/services/specializzazione.service';
import { AttivitaService } from '@/data/services/attivita.service';

const container = new ServiceContainer();
container.set('CrudService', CrudService);
container.set('AuthService', AuthService);
container.set('AnagraficaService', AnagraficaService);
container.set('SpecializzazioneService', SpecializzazioneService);
container.set('AttivitaService', AttivitaService);

export default container
